import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {CarsModel} from "../../../model/car.model";
import {CarService} from "../../../services/car.service";
import {FormControl, FormGroup} from "@angular/forms";
import {ChangeContext, LabelType, Options} from "ng5-slider";

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  @Output('carsFilters') carFilter: EventEmitter<CarsModel[]> = new EventEmitter<CarsModel[]>();

  cars: CarsModel[];
  carSelect: CarsModel[];
  minValue: number = 99;
  maxValue: number = 9999999999;
  minMileValue: number;
  maxMileValue: number;
  car: any;
  optionsMile: Options = {
    floor: 99,
    ceil: 500000,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>Min Km:</b>' + value  ;
        case LabelType.High:
          return '<b>Max Km:</b> ' + value;
        default:
          return 'R' + value;
      }
    }
  };
  sliderFormVal: FormGroup = new FormGroup({
    sliderControl: new FormControl([this.minValue, this.maxValue])
  });
  sliderFormMile: FormGroup = new FormGroup({
    sliderControls: new FormControl([this.optionsMile.floor, this.optionsMile.ceil])
  });
  seriesSelect: any;
  yearSelect: any;
  selectedMake: string;
  selectedSeries: string;
  selectedVariant: string;
  selectedYear: string;
  selectedSelling_price: string;
  selectedMileage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: CarService,
    public carsModel: CarsModel
  ) {}

  optionsPrice: Options = {
    floor: 0,
    ceil: 2000000,
    step: 10000,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>Min:</b> R' + value;
        case LabelType.High:
          return '<b>Max:</b> R' + value;
        default:
          return 'R' + value;
      }
    }
  };


  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.carsModel.make = params.get('make');
      this.carsModel.series = params.get('series');
      this.carsModel.year = params.get('year');
      this.carsModel.variant = params.get('variant');
      this.carsModel.selling_price = params.get('selling_price');
      this.carsModel.mileage = params.get('mileage');

      this.selectedMake = params.get('make') || '';
      this.selectedSeries = params.get('series') || '';
      this.selectedYear = params.get('year') || '';
      this.selectedVariant = params.get('variant') || '';
      this.selectedSelling_price = params.get('selling_price') || '';
      this.selectedMileage = params.get('mileage') || '';

      this.api.getAllCarsFilter(this.carsModel).subscribe(http => {
        console.log('this.cars1: ', http);
        this.cars = http;//.filter(x => x.make !== null);
        console.log('this.cars2: ', this.cars);
        // this.carSelect = http;
        this.carFilter.emit(this.cars);
      });
      this.api.getListData('&select=make,series,year').subscribe(http => {
        this.api.filterList = http;
        this.carSelect  = this.api.filterList;
      });
    });
  }

  changeValue(value, http) {
    switch (value) {
      case 'ascending':
        this.sortMakeAcs(http);
        break;
      case 'descending':
        this.sortMakeDecs(http);
        break;
      case 'latest':
        this.sortLatestAcs(http);
        break;
      default:
        this.sortMakeDecs(http);
    }
  }
  sortMakeAcs(http) {
    return http.sort((a, b) => a.selling_price - b.selling_price);
  }

  sortMakeDecs(http) {
    return http.sort((a, b) => b.selling_price - a.selling_price);
  }

  sortLatestAcs(http) {
    return http.sort((d1, d2) => new Date(d2.date_created).getTime() - new Date(d1.date_created).getTime());
  }
  public sortView() {
    switch (this.api.sortingVal) {
      case 'priceAsc':
        this.car.sort((a, b) => a.selling_price - b.selling_price);
        break;
      case 'priceDsc':
        this.car.sort((a, b) => b.selling_price - a.selling_price);
        break;
      case 'makeAsc':
        this.car.sort((a, b) => a.make.localeCompare(b.make)  );
        break;
      case 'makeDsc':
        this.car.sort((a, b) => b.make.localeCompare(a.make) );
        break;
      case 'yearAsc':
        this.car.sort((a, b) => a.year - b.year);
        break;
      case 'yearDsc':
        this.car.sort((a, b) => b.year - a.year);
        break;
      case 'sortBy':
        this.car.sort( (a, b) => new Date(b.date_created).getTime() - new Date(a.date_created).getTime());
        break;
      default:
        this.car.sort( (a, b) => new Date(b.date_created).getTime() - new Date(a.date_created).getTime());
    }
  }
  reset() {
    this.selectedSeries = '';
    this.selectedYear = '';
  }
  filterBy(event): void {
    this.carsModel.make = this.selectedMake;
    this.carsModel.series = this.selectedSeries;
    this.carsModel.variant = this.selectedVariant;
    this.carsModel.year = this.selectedYear;
    this.carsModel.selling_price = this.selectedSelling_price;
    this.carsModel.mileage = this.selectedMileage;
    this.api.getAllCarsFilter(this.carsModel).subscribe(http => {
      this.carSelect = this.api.filterList;
      this.seriesSelect = this.api.filterList.filter(obj => obj.make === event);
      this.yearSelect = this.api.filterList.filter(obj => obj.series === event);
      this.cars = http;
      this.carFilter.emit(this.cars);
      this.router.navigate(['/buy-a-car',
        {
          make: this.carsModel.make || '',
          series: this.carsModel.series || '',
          mileage: this.carsModel.mileage || '',
          selling_price: this.carsModel.selling_price || '',
          year: this.carsModel.year || '',
          priceLow: this.carsModel.lowValue || '',
          priceHigh: this.carsModel.highValue || '',
          kmLow: this.carsModel.mileageLow || '',
          kmHigh: this.carsModel.mileageHigh || '',
        }]
      );
    });
  }

  filterReset() {
    this.router.navigate(['/buy-a-car']);
    this.selectedMake = '';
    this.selectedSeries = '';
    this.selectedVariant = '';
    this.selectedYear = '';
    this.selectedSelling_price = '';
    this.selectedMileage = '';

    this.api.filterCars(this.carsModel).subscribe(http => {
      this.cars = http;
    });
  }
  onUserChangeEnd(changeContext: ChangeContext): void {
    this.carsModel.lowValue = changeContext.value;
    this.carsModel.highValue = changeContext.highValue;

    this.router.navigate(['/buy-a-car',
      {
        make: this.carsModel.make || '',
        series: this.carsModel.series || '',
        year: this.carsModel.year || '',
        priceLow: this.carsModel.lowValue || '',
        priceHigh: this.carsModel.highValue || '',
        kmLow: this.carsModel.mileageLow || '',
        kmHigh: this.carsModel.mileageHigh || '',
      }]
    );
  }
  onUserMileChangeEnd(changeContext: ChangeContext): void {
    this.carsModel.mileageLow = changeContext.value;
    this.carsModel.mileageHigh = changeContext.highValue;
    this.router.navigate(['/buy-a-car',
      {
        make: this.carsModel.make || '',
        series: this.carsModel.series || '',
        year: this.carsModel.year || '',
        priceLow: this.carsModel.lowValue || '',
        priceHigh: this.carsModel.highValue || '',
        kmLow: this.carsModel.mileageLow || '',
        kmHigh: this.carsModel.mileageHigh || '',
      }]
    );
  }
  filterBySeries(make: any) {
    this.seriesSelect = this.api.filterList;
    return this.seriesSelect.filter(item => item.make === make);
  }

  filterByYear(series: any) {
    this.yearSelect = this.api.filterList;
    return this.yearSelect.filter(item => item.series === series);
  }
}
